import React from "react";
import { Container } from "@mui/material";
import { Box } from "@mui/system";
import ReactTable from "@Components/ReactTable/ReactTable";
import { ListingPageContainer } from "./ListingPageTemplateStyles";
import PageTitle from "@Components/PageTitle/PageTitle";
import ServerPaginatedTable from "../../Components/ServerPaginatedTable/ServerPaginatedTable";

const ListingPageTemplate = ({
  title,
  PageIcon,
  iconColor,
  buttons,
  tableProps,
  serverPagination=false,
}) => {
  return (
    <ListingPageContainer className="listingPageContainer">
      <Container sx={{ pb: 5, pr: '0px !important', pl: '0px !important' }} disableGutters >
        <Box className="LabelButtonBox">
          <PageTitle
            title={title}
            PageIcon={PageIcon}
            iconColor={iconColor}
          ></PageTitle>
          {buttons && (
            <Box className="ButtonContainer">
              {buttons.map((button, index) => (
                <React.Fragment key={index}>{button}</React.Fragment>
              ))}
            </Box>
          )}
        </Box>
        <Box sx={{ pt: 3 }}>
          {serverPagination ? <ServerPaginatedTable {...tableProps} /> :
          <ReactTable {...tableProps} />}
        </Box>
      </Container>
    </ListingPageContainer>
  );
};

export default ListingPageTemplate;
